module.exports = __webpack_public_path__ + "static/media/100100logo.6b5fb008.jpg";